import { emptyFn } from '_/constants/common';
import Checkbox from 'antd/lib/checkbox';
import Tooltip from 'antd/lib/tooltip';
import React, { ReactElement } from 'react';

import { IFlowDestinationsCheckboxProps } from './FlowDestinations.types';

const FlowDestinationsCheckbox = (props: IFlowDestinationsCheckboxProps): ReactElement => {
  const { checked = false, disabled = false, onChange = emptyFn, tooltip } = props;

  const checkbox = <Checkbox checked={checked} disabled={disabled} onChange={onChange} />;

  return tooltip ? <Tooltip title={tooltip}>{checkbox}</Tooltip> : checkbox;
};

export default FlowDestinationsCheckbox;
